import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useQuickBooksCustomers } from '../../../../../hooks/requests/integrations';
import { useExternalCustomerSelection } from '../../hooks/use-external-customer-selection';

export const useQuickBooksCustomerSelection = () => {
  const { customers, ...rest } = useExternalCustomerSelection({
    provider: INTEGRATION_PROVIDERS.quickBooks,
    useCustomersHook: useQuickBooksCustomers,
  });

  return {
    quickBooksCustomers: customers,
    ...rest,
  };
};
